import React, { useContext } from 'react';
import { FILTER } from '@fiverr-private/listing_lib';
import Toggle from '../toggle';
import { useAppContext } from '../../../../../../context/listingsContext';
import { FilterContext } from '../../../../../../context/filterContext';
import { isBudgetActive } from '../../../../../util/budget';
import { HourlyRatesToggleProps } from './HourlyRatesToggle.types';
import { COPY_PREFIX } from './HourlyRatesToggle.constants';

export const HourlyRatesToggle: React.FC<HourlyRatesToggleProps> = ({ filter, ...rest }) => {
    const { inHourlyToggleExperiment } = useAppContext();
    const { activeFilters = {} } = useContext(FilterContext);

    const isBudgetFilterActive = isBudgetActive(activeFilters);

    if (!filter || !inHourlyToggleExperiment) {
        return null;
    }

    const tooltipText = isBudgetFilterActive ? `${COPY_PREFIX}.disabled_by_budget` : `${COPY_PREFIX}.description`;

    return (
        <Toggle
            selectedValue={FILTER.HOURLY_TOGGLE.SELECTED_VALUE}
            title={`${COPY_PREFIX}.title`}
            text={tooltipText}
            {...filter}
            {...rest}
            disabled={isBudgetFilterActive}
        />
    );
};
